import { Container } from './lib/container';
import Manager from './lib/manager';

export const PopupboxContainer = Container;
export const PopupboxManager = Manager;



// WEBPACK FOOTER //
// /Users/farynwork/projects/react-popupbox/src/index.js